import { render, staticRenderFns } from "./login_new.vue?vue&type=template&id=0dddfd72&"
import script from "./login_new.vue?vue&type=script&lang=js&"
export * from "./login_new.vue?vue&type=script&lang=js&"
import style0 from "./login_new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports